<template lang="pug">
  .container-outlayList.container-padding
    c-header
      template(slot="left")
        h3 营销账户管理
        h6 说明：当商家希望在富力的互联网产品上进行营销活动时，可以创建营销账户并往里面充值积力宝，然后在不同的业务场景下派发给用户使用。
      template(slot="right")
        el-button(type="primary", @click="showSettings") 预警配置
        el-button(type="primary", @click="showCreate") 添加营销账户
      c-box.container-filters
        el-form(:model="filters",label-position="right",label-width="100px")
          el-row(:gutter="10")
            el-col(:span="8")
              el-form-item(label="营销账户")
                el-input(v-model="filters.account_name")
            el-col(:span="8")
              el-form-item(label="账户 ID")
                el-input(v-model="filters.outlay_account_id")
            el-col(:span="8")
              el-form-item(label="")
                el-button(@click="setFilter",type="primary") 搜索
                el-button(@click="clearFilter", v-show="hasFilter") 清除

    c-box.outlayCard-container(v-loading="listLoading", :element-loading-fullscreen="false")
      el-card.outlayCard(v-for="p in list", :key="p.outlay_account_id", shadow="hover")
        .outlayCard-title(slot="header") {{ p.account_name }}
        .outlayCard-content ID: {{ p.outlay_account_id }}
        hr
        .outlayCard-options
          .outlayCard-copy(@click="copyAccountId(p.outlay_account_id)")
            fa-icon(:icon="['fa', 'clipboard']")
            span 复制 ID
          .outlayCard-detail(@click="showDetail(p.outlay_account_id)")
            span 详情
            fa-icon(:icon="['fa', 'arrow-alt-circle-right']")
    .container-pagination
      el-pagination(layout="sizes, prev, pager, next, total",
        :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
        @size-change="changeListSize", @current-change="getList")

    el-dialog(title="添加营销账户", :visible.sync="createAccount.show", v-loading="createAccount.loading")
      el-form(:model="createAccount", label-position="right", label-width="125px")
        el-form-item(label="说明") 您可以向营销账号内充值，并授权相关应用，将您的余额转换为积力宝、现金优惠券等形式，进行相关营销活动。
        el-form-item(label="") 账户名称不能超过 20 个字
        el-form-item(label="营销账户名称", required)
          el-input(v-model="createAccount.account_name")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()") 下一步
        el-button(@click="hideCreate()") 取消

    el-dialog(title="设置应用授权", :visible.sync="authApp.show")
      el-form(:model="authApp", label-position="right", label-width="100px")
        el-form-item(label="") 授权合作的应用操作您的营销账户，创建、发放积力宝和现金券。完成营销账户创建后，您可以随时在详情页面修改授权。
        .display-table.auth-table(v-loading="authApp.loading", :element-loading-fullscreen="false")
          .display-tr.auth-table-header
            .display-td.auth-table-td &nbsp;
            .display-td.auth-table-td(v-for="a in authApp.app_list")
              .auth-app-container
                .auth-app-icon(:class="'auth-app-icon-' + a.icon")
                .display-block {{ a.name }}
          .display-tr.auth-table-row(v-for="(bind, $index) in authApp.binding_array", :key="$index")
            .display-td.auth-table-td {{ authApp.biz_list[$index].biz_name }}
            .display-td.auth-table-td(v-for="(b, $$index) in bind.binding", :key="$$index")
              el-checkbox(v-model="b.operation", :true-label="1", :false-label="2")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveAuthApp()") 保存
        el-button(@click="hideAuthApp()") 取消

    el-dialog(title="修改预警配置", :visible.sync="settings.show", width="800px", v-loading="settings.loading")
      el-form(:model="settings", label-position="right", label-width="100px")
        el-form-item(label="说明") 当积力宝发放/剩余量触发预警值时，系统将自动发送邮件和短信到已绑定的邮箱和手机。
        el-form-item(v-for="(s, $index) in settings.settings", :key="$index")
          el-switch(v-model="s.status", :active-value="1", :inactive-value="2")
          span &nbsp;&nbsp;
          span 当 {{ s.statistical_mode | statistical_mode }} {{ s.frequency | frequency }} {{ s.check_type | check_type }} {{ s.warning_type | warning_type }}
          span &nbsp;&nbsp;
          el-input-number(v-model="s.threshold").display-inline-block
          span &nbsp;&nbsp;
          span 时触发预警
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveSettings()") 保存
        el-button(@click="hideSettings()") 取消

    verifier(ref="authApp", @success_verify="toSaveAuthApp", scene="BIND_APP", opt="MCH_VERIFY")
    verifier(ref="saveSettings", @success_verify="toSaveSettings", scene="WARNING_SETTINGS", opt="MCH_VERIFY")
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   20,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      filters: {
        account_name:       null,
        outlay_account_id:  null,
      },
      hasFilter:    false,

      createAccount:    {
        show:         false,
        loading:      false,
        account_name: null,
      },
      authApp: {
        show:               false,
        loading:            false,
        outlay_account_id:  null,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      },

      settings: {
        show:       false,
        loading:    false,
        settings:   [],
      },
    };
  },
  filters: {
    statistical_mode (source) {
      switch (source) {
        case 1:     return '全部营销帐号';
        case 2:     return '任意营销帐号';
        default:    return source;
      }
    },
    check_type (source) {
      switch (source) {
        case 1:     return '积力宝';
        case 2:     return '优惠券';
        default:    return source;
      }
    },
    warning_type (source) {
      switch (source) {
        case 1:     return '发放';
        case 2:     return '剩余';
        default:    return source;
      }
    },
    frequency (source) {
      switch (source) {
        case 'SINGLE':  return '';      // 单次
        case 'DAILY':   return '每日';
        case 'MONTH':   return '每月';
        default:        return source;
      }
    },
  },
  methods: {
    copyAccountId (content) {
      this.$clipboard(content);
      this.$message({
        type:     'success',
        message:  '账户 ID 已复制',
      });
    },
    showCreate () {
      this.createAccount = {
        show:         true,
        loading:      false,
        account_name: null,
      };
    },
    hideCreate () {
      this.createAccount = {
        show:         false,
        loading:      false,
        account_name: null,
      };
    },
    saveCreate () {
      const account_name = this.createAccount.account_name ? this.createAccount.account_name.trim() : '';
      if (!account_name) {
        this.$message({
          type:     'warning',
          message:  `请输入有效的账户名称。`,
        });
        return;
      } else if (account_name.length > 20) {
        this.$message({
          type:     'warning',
          message:  `账户名称不能超过20字。`,
        });
        return;
      }

      this.createAccount.loading = true;
      this.$store.dispatch('CREATE_OUTLAY_ACCOUNT', account_name).then(({ outlay_account_id }) => {
        this.hideCreate();
        this.getList(1);
        this.showAuthApp(outlay_account_id);
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `营销账户添加失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.createAccount.loading = false;
      });
    },

    showAuthApp (outlay_account_id) {
      this.authApp = {
        show:               true,
        loading:            false,
        outlay_account_id,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      };
      this.getAuthAppList(outlay_account_id);
    },
    hideAuthApp () {
      this.authApp = {
        show:               false,
        loading:            false,
        outlay_account_id:  null,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      };
    },
    getAuthAppList (outlay_account_id) {
      this.authApp.loading = true;
      return this.$store.dispatch('GET_AUTH_APP_LIST', outlay_account_id).then(({ app_list, binding_list, biz_list }) => {
        let list = [];
        biz_list.forEach((b) => {
          let biz = Object.assign({}, b, {
            binding:  [],
          });
          app_list.forEach((a) => {
            const app = {
              app_id:     a.app_id,
              biz_type:   biz.biz_type,
              operation:  1,            // Select All by default
            };

            biz.binding.push(app);
          });
          list.push(biz);
        });

        this.authApp.app_list = app_list;
        this.authApp.binding_array = list;
        this.authApp.biz_list = biz_list;

        return { app_list, binding_list, biz_list };
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取应用绑定信息失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.authApp.loading = false;
      });
    },
    saveAuthApp () {
      this.$refs.authApp.init();
    },
    toSaveAuthApp (biz_ticket) {
      let bind_req = [];
      this.authApp.binding_array.forEach((v) => {
        bind_req = [...bind_req, ...v.binding];
      });

      const jsonSource = {
        outlay_account_id:  this.authApp.outlay_account_id,
        bind_req,
      };
      const params = {
        json:   JSON.stringify(jsonSource),
        biz_ticket,
      };
      return this.$store.dispatch('BIND_AUTH_APP', params).then((data) => {
        this.hideAuthApp();
        this.$message({
          type:     'success',
          message:  '设置成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `设置应用授权失败。${code}：${msg}`,
        });
      });
    },

    showDetail (outlay_account_id) {
      this.$router.push(`/outlay/${outlay_account_id}`);
    },

    showSettings () {
      this.settings = {
        show:       true,
        loading:    false,
        settings:   [],
      };
      this.getSettings();
    },
    hideSettings () {
      this.settings = {
        show:       false,
        loading:    false,
        settings:   [],
      };
    },
    getSettings () {
      this.settings.loading = true;
      return this.$store.dispatch('GET_OUTLAY_WARNING_SETTINGS').then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          this.settings.settings = [...data];
        } else {                              // Default
          this.settings.settings = [
            {
              statistical_mode: 1,        // 所有
              check_type:       1,        // 积力宝
              warning_type:     1,        // 已发放
              threshold:        0,        // 数值
              status:           1,        // 启用
              frequency:        'DAILY',  // 每日
            },
            {
              statistical_mode: 2,        // 任意
              check_type:       1,        // 积力宝
              warning_type:     2,        // 剩余
              threshold:        0,        // 数值
              status:           1,        // 启用
              frequency:        'SINGLE', // 单次
            },
          ];
        }
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取预警配置失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.settings.loading = false;
      });
    },
    saveSettings () {
      this.$refs.saveSettings.init();
    },
    toSaveSettings (biz_ticket) {
      const settings = JSON.stringify(this.settings.settings);
      const params = { settings, biz_ticket };

      this.settings.loading = true;
      return this.$store.dispatch('SET_OUTLAY_WARNING_SETTINGS', params).then((data) => {
        this.hideSettings();
        this.$message({
          type:     'success',
          message:  '修改成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `修改预警配置失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.settings.loading = false;
      });
    },

    setFilter () {
      if (this.filters.account_name || this.filters.outlay_account_id) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    clearFilter () {
      this.filters = {
        account_name:       null,
        outlay_account_id:  null,
      };
      this.hasFilter = false;
      this.getList(1);
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters);
      this.$store.dispatch('GET_OUTLAY_ACCOUNT_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getList(1);
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-outlayList {
  .outlayCard-container {
    .flex(normal, flex-start);
    flex-wrap: 	      wrap;
  }
  .outlayCard {
    .border-box;
    width:    23%;
    margin:   10px 1%;

    .el-card__header {
      .bold;
      .break-all;

      padding:      10px;
      font-size:    14px;
    }
    .el-card__body {
      padding:      10px;
      font-size:    12px;
    }
  }

  .outlayCard-options {
    .flex(center, space-between);

    svg+span, span+svg {
      margin-left:    .5em;
    }
  }
  .outlayCard-copy, .outlayCard-detail {
    cursor:   pointer;
  }

  .auth-table {
    .display-table;
  }
  .auth-table-header {
    .display-tr;
  }
  .auth-table-row {
    .display-tr;

    .auth-table-td {
      &:first-child {
        .align-right;
      }
    }
  }
  .auth-table-td {
    .align-center;
    padding:  .5em 0;
  }

  .auth-app-container {
    .flex(center, center);
  }
  .auth-app-icon {
    width:    32px;
    height:   32px;
    margin-right:   8px;

    background-position:  center center;
    background-size:      contain;
    background-repeat:    no-repeat;
  }
}
</style>